import { useRouter } from "next/router";
import { ReactNode, useEffect } from "react";
import { useQuery } from "react-query";
import { getAuth0SessionData } from "../../lib/api/user";
import { setAuthenticatedSignupPending } from "./authenticated-signup-return-to";

type AuthenticatedSignupGateProps = {
  children: (args: { isCheckingAuth0Session: boolean }) => ReactNode;
  returnTo?: string;
};

export function AuthenticatedSignupGate({
  children,
  returnTo,
}: AuthenticatedSignupGateProps) {
  const router = useRouter();
  const { data: auth0Session, isLoading: isCheckingAuth0Session } = useQuery(
    "auth0-session",
    getAuth0SessionData,
    { retry: false }
  );

  useEffect(() => {
    if (auth0Session || isCheckingAuth0Session || !router.isReady) return;

    const destination = returnTo || router.asPath;

    setAuthenticatedSignupPending();

    window.location.replace(
      `/auth/login?screen_hint=signup&returnTo=${encodeURIComponent(
        destination
      )}`
    );
  }, [auth0Session, isCheckingAuth0Session, returnTo, router]);

  if (!auth0Session) return null;

  return <>{children({ isCheckingAuth0Session })}</>;
}
